import { createFileRoute } from "@tanstack/react-router";
import ChronicPainPage from "@/pages/ChronicPainPage";
import { buildConditionSchema } from "@/components/ConditionPageLayout";
export const Route = createFileRoute("/chronic-pain-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Chronic Pain Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Chronic pain treatment in Coral Springs, FL. Ketamine therapy and supportive care for chronic pain conditions at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:title",
          content: "Chronic Pain Coral Springs Fl | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Chronic pain treatment in Coral Springs, FL. Ketamine therapy and supportive care for chronic pain conditions at Neuro Wellness TMS Free consultation available.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/chronic-pain-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/chronic-pain-coral-springs-fl",
        },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            buildConditionSchema({
              seoTitle:
                "Ketamine for Chronic Pain Management Coral Springs, FL | Neuro Wellness",
              seoDescription:
                "Relieve chronic pain with non-opioid IV Ketamine infusion therapy at Neuro Wellness TMS Centers of America in Coral Springs, FL. Advanced pain management.",
              canonical: "/chronic-pain-coral-springs-fl",
              breadcrumbs: [
                { name: "Services", href: "/services-directory" },
                {
                  name: "Conditions Treated",
                  href: "/ketamine-treatment-coral-springs-fl",
                },
                {
                  name: "Chronic Pain",
                  href: "/chronic-pain-coral-springs-fl",
                },
              ],
            }),
          ),
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ChronicPainPage />;
}
